// extracted by mini-css-extract-plugin
module.exports = {"bundle-popup":"BundlePopup_bundle-popup__Pzj1U"};